import { Box, MenuList } from '@chakra-ui/react';

export const DropdownList = (props) => (
  <Box zIndex="dropdown">
    <MenuList borderRadius="10px" {...props} />
  </Box>
);
